export default __webpack_public_path__ + "static/media/330_portfolio03-it-web.58b0fe28.png";